import { Row, Col, Card, CardBody, Badge } from 'reactstrap';
import cn from 'classnames';
import style from './expandedView.module.css';
import { ReactComponent as PaidIcon } from '@assets/images/Fireboard/paid.svg';
import { ReactComponent as PhoneIcon } from '@assets/images/Fireboard/call.svg';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import styles from '../Body/ChecksList/checklist.module.css';
import { getEllapsedTime, getRemainingTime } from '../Common/Timer';
import { getTimeInHrsMins } from '../../../../utility/fireboardUtil';
import { LABEL } from '../../../../veriables';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const ExpandOrderDetailsSection = ({
  filteredCheck = {},
  currency,
  suppressTipsOnFireBoard,
  mode,
}) => {
  const modeSectionVisibility = {
    DEFAULT: { order: true, delivery: true },
    ON_PREMISE: { order: false, delivery: false },
    OFF_PREMISE: { order: true, delivery: true },
    OFF_PREMISE_VENUE: { order: true, delivery: true },
    TABLE_DELIVERY: { order: false, delivery: false },
    FUTURE_ORDERS: { order: true, delivery: true },
  };

  const DisplaySection = ({ mode, section, children }) => {
    if (!modeSectionVisibility[mode]?.[section]) return null;
    return children;
  };

  const [order0] = filteredCheck?.orders || [];
  const checkDetails =
    {
      mode: filteredCheck?.mode,
      modeBgColor: filteredCheck?.modeBgColor,
      checkNumber: filteredCheck?.number,
      status: filteredCheck?.status,
      unpaidAmount: filteredCheck?.unpaidAmount,
      paidAmount: filteredCheck?.paidAmount,
      openDateDetails: filteredCheck?.openDateDetails,
      employeeFirstName: filteredCheck?.employeeFirstName,
      employeeLastName: filteredCheck?.employeeLastName,
      tableInfo: filteredCheck?.tableInfo,
      dueTime: filteredCheck?.dueTime,
      remainingTimeDetails: filteredCheck?.remainingTimeDetails,
      totalAmount: filteredCheck?.totalAmount,
    } || {};

  const orderDetails =
    {
      orderName: filteredCheck?.orderDetails,
      pickupDate: filteredCheck?.pickupDate,
      tableInfo: filteredCheck?.tableInfo,
      vehicleInfo: order0?.vehicleInfo,
      orderNote: order0?.orderNote,
    } || {};

  const vendorDetails =
    {
      vendorName: order0?.marketplaceVendorName || '---',
      vendorPhonenumber: order0?.marketplacePhoneNumber || '---',
      orderId: order0?.marketplaceOrderId,
      deliveryAdd: order0?.address || '---',
    } || {};
  const paymentDetails =
    {
      subTotalAmount: `${currency}${filteredCheck?.subTotalAmount?.toFixed(2)}`,
      itemAmount: `${currency}${filteredCheck?.itemAmount?.toFixed(2)}`,
      discountAmount: `${currency}${filteredCheck?.discountAmount?.toFixed(2)}`,
      serviceCharge: `${currency}${filteredCheck?.serviceChargeAmount?.toFixed(
        2
      )}`,
      taxAmount: `${currency}${filteredCheck?.taxAmount?.toFixed(2)}`,
      tipAmount: `${currency}${filteredCheck?.tipAmount?.toFixed(2)}`,
      paidAmount: `${currency}${filteredCheck?.paidAmount?.toFixed(2)}`,
      dueAmount: `${currency}${filteredCheck?.unpaidAmount?.toFixed(2)}`,
    } || {};
  return (
    <div
      className={cn(
        'h-100 d-flex flex-column position-relative',
        style.leftContainer,
        style.subcontainerGap
      )}
    >
      <OrderHeaderSection checkDetails={checkDetails} mode={mode} />
      <DisplaySection mode={mode} section="order">
        <OrderDetailSection orderDetails={orderDetails} />
      </DisplaySection>
      <DisplaySection mode={mode} section="delivery">
        <VendorDetailSection vendorDetails={vendorDetails} />
      </DisplaySection>
      <PaymentSection
        paymentDetails={paymentDetails}
        suppressTipsOnFireBoard={suppressTipsOnFireBoard}
      />
    </div>
  );
};
export default ExpandOrderDetailsSection;

const elapsedOrRemaining = {
  DEFAULT: { elapesd: true, dueTime: true },
  ON_PREMISE: { elapesd: true, dueTime: true },
  OFF_PREMISE: { elapesd: false, dueTime: true },
  OFF_PREMISE_VENUE: { elapesd: false, dueTime: true },
  TABLE_DELIVERY: { elapesd: true, dueTime: false },
  FUTURE_ORDERS: { elapesd: false, dueTime: false },
};

const TimeCounter = ({ mode, openDateDetails, remainingTimeDetails }) => {
  const showElapsed = elapsedOrRemaining[mode].elapesd;
  const { timer: elapsedTimer, color: elapsedColor } = getEllapsedTime(
    openDateDetails?.ellapsedTime
  ) || { timer: null, color: null };
  const { timer: remainingTimer, color: remainingColor } = getRemainingTime(
    remainingTimeDetails?.remainingTime
  ) || { timer: null, color: null };

  return (
    <div className="d-flex">
      <span className={cn('pr-2', style.smallText)}>
        {showElapsed ? FLABEL().DETAILS_ELAPSED : FLABEL().DETAILS_REMAINING}
      </span>
      <div
        className={cn(
          styles.timerText,
          'rounded d-flex justify-content-center align-items-center'
        )}
      >
        {showElapsed ? (
          <span
            style={{
              color: elapsedColor,
              '--ellapsed-color': elapsedColor,
            }}
          >
            {elapsedTimer}
          </span>
        ) : (
          <span
            style={{
              color: remainingColor,
              '--ellapsed-color': remainingColor,
            }}
          >
            {remainingTimer}
          </span>
        )}
      </div>
    </div>
  );
};

const getFormattedDateTime = field => {
  if (field) {
    const date = new Date(field);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const time = getTimeInHrsMins(field);
    return `${month}/${day} ${time}`;
  }
  return '';
};

const OrderHeaderSection = ({ checkDetails, mode }) => {
  const currenySymbol = LABEL().CURRENCY_SYMBOL;
  const isUnpaid =
    checkDetails?.unpaidAmount > 0 ||
    (checkDetails?.unpaidAmount === 0 && checkDetails?.paidAmount === 0);

  const isPartialPaid =
    checkDetails?.unpaidAmount > 0 &&
    checkDetails?.unpaidAmount < checkDetails?.totalAmount;

  return (
    <Card className={cn(style.leftSectionSubSection)}>
      <CardBody className="p-0">
        <Row className="d-flex mx-0 align-items-center">
          <Col className="p-0 d-flex align-items-center col-5">
            <span
              className={cn(
                style.modeIcon,
                'd-flex justify-content-center align-items-center'
              )}
              style={{ backgroundColor: checkDetails.modeBgColor }}
            >
              {checkDetails?.mode}
            </span>
            <span
              className={cn(
                'pl-2 fs_18 fw-500',
                style.checkNumber,
                checkDetails?.checkNumber?.length > 13
                  ? style.checkTruncate
                  : ''
              )}
            >
              #{checkDetails?.checkNumber}
            </span>
          </Col>
          <Col
            className={cn(
              'p-0 d-flex align-items-center justify-content-end col-7',
              style.pillsConatiner
            )}
          >
            <Badge
              className={cn(
                'fs_14 fw-600 d-flex align-items-center justify-content-center',
                isPartialPaid
                  ? style.partialPaidPill
                  : isUnpaid
                  ? style.unpaidPill
                  : style.paidPill
              )}
            >
              <span className={cn('h-100', style.paidIcon)}>
                {!isPartialPaid && <PaidIcon />}
              </span>
              <span className="pl-1">
                {isPartialPaid ? (
                  <>
                    Due:{' '}
                    {`${currenySymbol}${checkDetails?.unpaidAmount?.toFixed(
                      2
                    )}`}
                  </>
                ) : isUnpaid ? (
                  FLABEL().DETAILS_UNPAID
                ) : (
                  FLABEL().DETAILS_PAID
                )}
              </span>
            </Badge>
            <Badge
              className={cn(
                'fs_12 fw-500 d-flex justify-content-center align-items-center',
                style.statusPill
              )}
              style={{
                backgroundColor: checkDetails?.status?.color,
                border: checkDetails?.status?.border,
              }}
            >
              <span>{checkDetails?.status?.status}</span>
            </Badge>
          </Col>
        </Row>
        <Row className="pt-2 d-flex mx-0 align-items-center fw-500">
          <span>{checkDetails?.employeeFirstName}</span>
          <span className="pl-2">{checkDetails?.employeeLastName}</span>
        </Row>
        <Row
          className={cn('pt-2 d-flex mx-0 align-items-center', style.smallText)}
        >
          <span className="pr-2">
            {checkDetails?.openDateDetails?.openDate}
          </span>
          |
          <span className="pl-2">
            {checkDetails?.openDateDetails?.closeDate}
          </span>
        </Row>
        <Row className="pt-2 d-flex mx-0 align-items-center justify-content-between">
          {elapsedOrRemaining[mode]?.dueTime && (
            <span className="pr-1">
              <span className={style.smallText}>{FLABEL().DETAILS_DUETIME}:</span>{' '}
              <span>{checkDetails?.dueTime}</span>
            </span>
          )}
          <TimeCounter
            mode={mode}
            openDateDetails={checkDetails?.openDateDetails}
            remainingTimeDetails={checkDetails?.remainingTimeDetails}
          />
        </Row>
      </CardBody>
    </Card>
  );
};

const OrderDetailSection = ({ orderDetails }) => {
  return (
    <Card className={cn(style.leftSectionSubSection)}>
      <CardBody className="p-0">
        <Row className="d-flex mx-0 align-items-center">
          <Col className="p-0 d-flex align-items-center fw-500">
            <span>{orderDetails?.tableInfo?.stationName}</span>
          </Col>
        </Row>
        <Row className="pt-2 d-flex mx-0 align-items-center">
          <span className={style.phoneIcon}>
            <PhoneIcon />
          </span>
          <span>{orderDetails.orderName?.phoneNumber || '---'}</span>
        </Row>
        <Row className="pt-2 d-flex mx-0 align-items-center">
          <span>{orderDetails?.vehicleInfo || '---'}</span>
        </Row>
        <Row
          className={cn('pt-2 d-flex mx-0 align-items-center', style.smallText)}
        >
          {getFormattedDateTime(orderDetails?.pickupDate) || '---'}
        </Row>
        <Row
          className={cn(
            'mt-2 d-flex mx-0 align-items-center justify-content-between px-2 fw-400 text-truncate br-6',
            style.orderNote
          )}
        >
          {orderDetails?.note || orderDetails?.orderNote}
        </Row>
      </CardBody>
    </Card>
  );
};

const VendorDetailSection = ({ vendorDetails }) => {
  return (
    <Card className={cn(style.leftSectionSubSection)}>
      <CardBody className="p-0">
        <Row className="d-flex mx-0 align-items-center">
          <span>{vendorDetails?.deliveryAdd}</span>
        </Row>
        <Row className="pt-2 d-flex mx-0 align-items-center">
          <span className={style.phoneIcon}>
            <PhoneIcon />
          </span>
          {vendorDetails?.vendorPhonenumber !== '---'
            ? getFormatedPhoneNumber(vendorDetails?.vendorPhonenumber)
            : '---'}
        </Row>
        <Row
          className={cn('pt-2 d-flex mx-0 align-items-center', style.smallText)}
        >
          {vendorDetails?.orderId ? <span>Order# {vendorDetails?.orderId}</span> : '---'}
        </Row>
        <Row className="pt-2 d-flex mx-0 align-items-center">
          <Col className="p-0 d-flex align-items-center">
            <span>{vendorDetails?.vendorName}</span>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

const PaymentSection = ({ paymentDetails, suppressTipsOnFireBoard }) => {
  return (
    <Card
      className={cn('w-100 position-absolute', style.leftSectionSubSection)}
      style={{ bottom: 0 }}
    >
      <CardBody className="p-0">
        <Row className="d-flex mx-0 align-items-center">
          <AmountDetail
            label={FLABEL().DETAILS_SUBTOTAL}
            value={paymentDetails.subTotalAmount}
            align={'justify-content-start'}
            xs={6}
          />
          <AmountDetail
            label={FLABEL().DETAILS_ITEMS}
            value={paymentDetails.itemAmount}
            align={'justify-content-end'}
            xs={6}
          />
        </Row>
        <Row className="pt-2 d-flex mx-0 align-items-center">
          <AmountDetail
            label={FLABEL().DETAILS_DISCOUNTS}
            value={paymentDetails.discountAmount}
            align={'justify-content-start'}
            xs={4}
          />
          <AmountDetail
            label={FLABEL().DETAILS_CHARGES}
            value={paymentDetails.serviceCharge}
            align={'justify-content-center'}
            xs={5}
          />
          <AmountDetail
            label={FLABEL().DETAILS_TAX}
            value={paymentDetails.taxAmount}
            align={'justify-content-end'}
            xs={3}
          />
        </Row>
        <Row className="pt-2 d-flex mx-0 align-items-center justify-content-center">
          <Col
            style={{ border: '1px solid var(--checkdetail-horizontal-stroke)' }}
          />
        </Row>
        <Row className="pt-2 d-flex mx-0 align-items-center">
          {suppressTipsOnFireBoard ? null : (
            <AmountDetail
              label={FLABEL().DETAILS_TIP}
              value={paymentDetails.tipAmount}
              align={'justify-content-start'}
              xs={4}
            />
          )}
          <AmountDetail
            label={FLABEL().DETAILS_PAID}
            value={paymentDetails.paidAmount}
            align={'justify-content-center'}
            xs={4}
          />
          <AmountDetail
            label={FLABEL().DETAILS_DUE}
            value={paymentDetails.dueAmount}
            align={'justify-content-end'}
            xs={4}
            customClass={style.dueAmountColor}
          />
        </Row>
      </CardBody>
    </Card>
  );
};

const AmountDetail = ({ label, value, align, xs, customClass }) => {
  return (
    <Col xs={xs} className={cn(`p-0 d-flex align-items-center ${align}`)}>
      <span className={cn(style.paymentLabel)}>{label}</span>
      <span className={cn(style.plAmount, customClass)}>{value}</span>
    </Col>
  );
};
